import React from 'react'
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const contentStyle = {
   height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fff',
};
const content = <div style={contentStyle} />;
const PageLoader = ({}) => {
    return (
        <>
            <Spin tip="Please wait! Data is being pushed to the server. Do not refresh the page.">{content}</Spin>
        </>
    )
}

export default PageLoader